import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ItemData } from '../combo/item-data';

@Component({
    selector: 'custom-slider',
    templateUrl: './custom-slider.component.html',
    styleUrls: ['./custom-slider.component.less']
})
export class CustomSliderComponent {

    @Input()
    testId: string = '';

    @Input()
    brixxSinglePlansCountItems: Array<ItemData> = [];

    @Input()
    plansCount: string = '1';

    @Input()
    value: number = 0;

    @Input()
    initialPlanCount: number = 1;

    @Output()
    plansCountChange = new EventEmitter<string>();

    @ViewChild('rangeInput')
    rangeInput!: ElementRef;

    @ViewChild('markersContainer')
    markersContainer!: ElementRef;

    isBusinessDoctors: boolean = false;

    constructor() {
        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['initialPlanCount'] && changes['initialPlanCount'].currentValue > 1) {

            this.value = this.brixxSinglePlansCountItems.findIndex(it => it.elementId == this.initialPlanCount);

            let selectedPlanItem = this.brixxSinglePlansCountItems[this.value];
            this.plansCount = selectedPlanItem.elementId!.toString();

            this.plansCountChange.emit(selectedPlanItem.id);
            this.updateBackground();
        }
    }

    onInputChange(event: any): void {
        this.value = event.target.value;
        let selectedPlanItem = this.brixxSinglePlansCountItems[this.value];
        this.plansCount = selectedPlanItem.elementId!.toString();

        this.plansCountChange.emit(selectedPlanItem.id);        
        this.updateBackground();
    }

    private updateBackground() { 
        const range = this.rangeInput.nativeElement;
        const min = range.min;
        const max = range.max <= 0 ? this.brixxSinglePlansCountItems.length - 1 : range.max;
        range.style.backgroundSize = ((this.value - min) / (max - min)) * 100 + '% 100%';
    }

}